import {
  CaretakerDetailsInfoProDto,
  CaretakerDetailsInfoPro,
  ProSubscriptionPlan,
  ProSubscriptionPlanDto,
  InfoDiscountCouponDto,
  InfoDiscountCoupon,
  ProSubscriptionUpdatePaymentMethodDto,
} from '$domain/model/pro/pro.model'

const mapSusbcriptionProPaymentDtoToView = selectedPlan => {
  if (selectedPlan === ProSubscriptionPlanDto.monthly) {
    return ProSubscriptionPlan.monthly
  }
  if (selectedPlan === ProSubscriptionPlanDto.yearly) {
    return ProSubscriptionPlan.yearly
  }

  return ProSubscriptionPlan.monthly
}

export const mapCaretakerDetailsInfoProDtoToView = (
  detailsInfoPro: CaretakerDetailsInfoProDto,
): CaretakerDetailsInfoPro => {
  return {
    selectedPlan: detailsInfoPro.selectedPlan ? mapSusbcriptionProPaymentDtoToView(detailsInfoPro.selectedPlan) : '',
    renewalDate: detailsInfoPro.renewalDate ? detailsInfoPro.renewalDate : '',
    lastNumbersOfCard: detailsInfoPro.lastNumbersOfCard ? detailsInfoPro.lastNumbersOfCard : '',
    endDate: detailsInfoPro.endDate ? detailsInfoPro.endDate : '',
    enabledDate: detailsInfoPro.enabledDate ? detailsInfoPro.enabledDate : '',
    couponCode: detailsInfoPro.couponCode ? detailsInfoPro.couponCode : '',
    freeMonths: detailsInfoPro.freeMonths ? detailsInfoPro.freeMonths : 0,
    cardError: detailsInfoPro.cardError ? detailsInfoPro.cardError : false,
  }
}

export const mapInfoDiscountCouponDtoToView = (infoCoupon: InfoDiscountCouponDto): InfoDiscountCoupon => {
  return {
    freeMonths: infoCoupon.freeMonths ? infoCoupon.freeMonths : 0,
  }
}

export const mapProSubscriptionUpdatePaymentMethodToDto = (
  newPaymentMethodId: string,
): ProSubscriptionUpdatePaymentMethodDto => {
  return {
    newPaymentMethodId: newPaymentMethodId ? newPaymentMethodId : '',
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/pro/pro.mapper.ts